import { render } from "./NewAlienPlayerForm.vue?vue&type=template&id=64bc8a3b&scoped=true"
import script from "./NewAlienPlayerForm.vue?vue&type=script&lang=js"
export * from "./NewAlienPlayerForm.vue?vue&type=script&lang=js"

import "./NewAlienPlayerForm.vue?vue&type=style&index=0&id=64bc8a3b&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bc8a3b"]])

export default __exports__